import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SystemAssetCaptureComponent } from './system-asset-capture.component';

import {
  SystemAssetCaptureCreateOrUpdateComponent
} from './system-asset-capture-create-or-update/system-asset-capture-create-or-update.component';

import {
  SystemAssetCaptureFileCreateOrUpdateComponent
} from './system-asset-capture-file-create-or-update/system-asset-capture-file-create-or-update.component';

import {
  SystemAssetManualCreateOrUpdateComponent
} from './system-asset-manual-create-or-update/system-asset-manual-create-or-update.component';

const routes: Routes = [
  // System Asset Capture list
  {
    path: '',
    component: SystemAssetCaptureComponent
  },

  // Create asset source
  {
    path: 'create',
    component: SystemAssetCaptureCreateOrUpdateComponent,
    data: { create: true }
  },

  // Update asset source
  {
    path: 'update/:assetsourceId',
    component: SystemAssetCaptureCreateOrUpdateComponent,
    data: { create: false }
  },

  // Create asset source using file
  {
    path: 'file/create',
    component: SystemAssetCaptureFileCreateOrUpdateComponent,
    data: { create: true }
  },

  // Update asset source using file
  {
    path: 'file/update/:assetsourceId',
    component: SystemAssetCaptureFileCreateOrUpdateComponent,
    data: { create: false }
  },

  // Create system asset manually
  {
    path: 'asset-create',
    component: SystemAssetManualCreateOrUpdateComponent,
    data: { create: true }
  },

  // Update system asset
  {
    path: 'update-asset/:assetId',
    component: SystemAssetManualCreateOrUpdateComponent,
    data: { create: false }
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],

  exports: [
    RouterModule
  ]
})
export class SystemAssetCaptureRouter {}